import React, { useState } from 'react'

export default function DownloadSecurityCSV({advisoriesMappedByCve}) {
    const [rows, setRows] = useState(null)
    const titles = ["ID", "CWE", "KEV", "CVSS", "EPSS", "SEVERITY", "DESCRIPTION", "COUNT","COMPONENTS"]

    const populateRows = () => {
        const rows = []
        Object.keys(advisoriesMappedByCve).forEach((cve) => {
            const advice = advisoriesMappedByCve[cve]
            const row = []
            try {
                if (cve.startsWith("CVE")) row.push(cve)
                else row.push("MET-"+cve.split("-")[0])
                row.push(advice.cwe)
                row.push(advice.kevEntry ? (advice.kevEntry.exploited ? "EXPLOITED": "LISTED") : "")
                row.push(advice.cvss)
                row.push(advice.epss)
                row.push(advice.severity)
                row.push(`"${advice.description.replace(/"/g, '""')}"`)
                row.push(advice.affectedComponents.length)
                advice.affectedComponents.forEach((component) => {
                    const library = component.dependency.library
                    row.push(`${library.language}:${library.name}`)
                })
                rows.push(row)
            } catch(e) {
                console.error(e)
            }
        })
        setRows(rows)
        return rows
    }
    const convertToCsv = (rows) => {
        const cvsRows = [titles]
        rows.forEach((row) => {
            cvsRows.push(row.join(","))
        })
        return cvsRows.join("\n")
    }
    const download = () => {
        let localRows = rows
        if (!localRows) {
            localRows = populateRows()
        }
        const vulnerabilitesCsv = convertToCsv(localRows)
        const file = new File([vulnerabilitesCsv], "vulnerabilites.csv", {type: "text/csv"})
        const anchor = document.createElement("a")
        const url = URL.createObjectURL(file)
        anchor.download = file.name
        anchor.href = url
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
    }
    return (
    <span onClick={download} style={{cursor: "pointer", marginLeft: "10px"}} title="Export to csv format">
        <i className="fa-solid fa-file-csv"></i>
    </span>
  )
}
